"use client"

import React, { useState, useEffect } from "react"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { cn } from "@/lib/utils"

interface NavItem {
	id: string
	label: string
	url: string | { slug: string } | null
	isCta?: boolean
}

interface HeaderNavClientProps {
	navigation: NavItem[]
}

export const HeaderNavClient: React.FC<HeaderNavClientProps> = ({
	navigation,
}) => {
	const pathname = usePathname()
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	return (
		<nav className="flex flex-1 items-center justify-center">
			<div className="flex items-center gap-8">
				{navigation.map((navItem) => {
					const url = navItem.url
					let href = "#"

					if (typeof url === "string") {
						href = url
					} else if (typeof url === "object" && url?.slug) {
						const slug = url.slug
						href = slug === "home" || slug === "/" ? "/" : `/${slug}`
					}

					const isCta = navItem.isCta

					// Si es CTA, no mostrar en navegación normal
					if (isCta) {
						return null
					}

					// Si no hay href, saltar
					if (href === "#") {
						return null
					}

					const isActive =
						mounted &&
						(pathname === href || (href !== "/" && pathname.startsWith(href)))

					return (
						<Link
							key={navItem.id || navItem.label}
							href={href}
							aria-current={isActive ? "page" : undefined}
							className={cn(
								"group relative text-sm font-semibold transition-colors duration-200 hover:text-primary",
								isActive ? "text-primary" : "text-gray-600",
							)}
						>
							{navItem.label}
							<span
								className={cn(
									"pointer-events-none absolute -bottom-1 left-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full",
									isActive ? "w-full" : "w-0",
								)}
							/>
						</Link>
					)
				})}
			</div>
		</nav>
	)
}
